export default "__VITE_ASSET__AZ30v7je__"